import {
  useTranslate, TextField, useRecordContext, TextFieldProps,
} from 'react-admin';
import get from 'lodash/get';

export const TimeGranularityField = ({ source, ...rest }: TextFieldProps & { source: string }) => {

  const translate = useTranslate();
  const record = useRecordContext();

  const type = get(record, `${source}.type`);
  const granularityType = type
    ? translate(`general.text.time_granularity_types.${type}`, { smart_count: get(record, `${source}.value`) ?? 0 })
    : translate('general.text.none');

  return <TextField source="value" record={{ value: `${granularityType}` }} {...rest} />;

};
